




















import { Vue, Component, Prop } from "vue-property-decorator";
import { GraceItem as IGraceItem } from "@/interface/grace";
import { star } from "@/http/grace.api";
import starActiveImg from "@/assets/star_active.png";
import starImg from "@/assets/star.png";
import defaultImg from "@/assets/old_default.jpg";
@Component
export default class GraceItem extends Vue {
  @Prop() data!: IGraceItem;
  get getStarUrl() {
    return this.data.like ? starActiveImg : starImg;
  }
  get getImgUrl() {
    const { imageUrl } = this.data;
    return imageUrl ? window.StaticUrl + this.data.imageUrl : defaultImg;
  }
  jumpDetail(data: IGraceItem) {
    if (data.status !== 0) return;
    this.$router.push(`/graceDetail/${data.id}`);
    // @click="$router.push(`/graceDetail/${data.id}`)"
  }
  async star() {
    const { id, like } = this.data;
    const res = await star({
      id,
      like: +!like
    });
    this.data = Object.assign(this.data, {
      likeCnt: like ? this.data.likeCnt - 1 : this.data.likeCnt + 1,
      like: !like
    });
  }
}
